import {
  AUTOMATIONS_FREQ_FIVE_PER_WEEK,
  AUTOMATIONS_FREQ_FOUR_PER_WEEK,
  AUTOMATIONS_FREQ_ONE_PER_DAY,
  AUTOMATIONS_FREQ_SIX_PER_WEEK,
  AUTOMATIONS_FREQ_THREE_PER_WEEK,
} from "../i18n/keysTranslations";

export const FREQUENCY_ONE_PER_DAY = "1_per_day";
export const FREQUENCY_THREE_PER_WEEK = "3_per_week";
export const FREQUENCY_FOUR_PER_WEEK = "4_per_week";
export const FREQUENCY_FIVE_PER_WEEK = "5_per_week";
export const FREQUENCY_SIX_PER_WEEK = "6_per_week";

export const FREQUENCY_PRESETS = {
  [FREQUENCY_ONE_PER_DAY]: { postsPerPeriod: 1, period: "day" },
  [FREQUENCY_THREE_PER_WEEK]: { postsPerPeriod: 3, period: "week" },
  [FREQUENCY_FOUR_PER_WEEK]: { postsPerPeriod: 4, period: "week" },
  [FREQUENCY_FIVE_PER_WEEK]: { postsPerPeriod: 5, period: "week" },
  [FREQUENCY_SIX_PER_WEEK]: { postsPerPeriod: 6, period: "week" },
};

export const FREQUENCY_LABEL_KEYS = {
  [FREQUENCY_ONE_PER_DAY]: AUTOMATIONS_FREQ_ONE_PER_DAY,
  [FREQUENCY_THREE_PER_WEEK]: AUTOMATIONS_FREQ_THREE_PER_WEEK,
  [FREQUENCY_FOUR_PER_WEEK]: AUTOMATIONS_FREQ_FOUR_PER_WEEK,
  [FREQUENCY_FIVE_PER_WEEK]: AUTOMATIONS_FREQ_FIVE_PER_WEEK,
  [FREQUENCY_SIX_PER_WEEK]: AUTOMATIONS_FREQ_SIX_PER_WEEK,
};

export const AUTOMATION_FREQUENCY_OPTIONS = [
  {
    value: FREQUENCY_THREE_PER_WEEK,
    labelKey: AUTOMATIONS_FREQ_THREE_PER_WEEK,
  },
  {
    value: FREQUENCY_FOUR_PER_WEEK,
    labelKey: AUTOMATIONS_FREQ_FOUR_PER_WEEK,
  },
  {
    value: FREQUENCY_FIVE_PER_WEEK,
    labelKey: AUTOMATIONS_FREQ_FIVE_PER_WEEK,
  },
  {
    value: FREQUENCY_SIX_PER_WEEK,
    labelKey: AUTOMATIONS_FREQ_SIX_PER_WEEK,
  },
  {
    value: FREQUENCY_ONE_PER_DAY,
    labelKey: AUTOMATIONS_FREQ_ONE_PER_DAY,
  },
];

export const resolveFrequencyFromKey = (frequencyKey) =>
  FREQUENCY_PRESETS[frequencyKey] || FREQUENCY_PRESETS[FREQUENCY_ONE_PER_DAY];

export const getFrequencyLabelKey = (frequencyKey) =>
  FREQUENCY_LABEL_KEYS[frequencyKey] ||
  FREQUENCY_LABEL_KEYS[FREQUENCY_ONE_PER_DAY];

/** Weekly ceiling used in the paywall. Daily posting is 7 days. */
const FREQUENCY_POSTS_PER_WEEK = {
  [FREQUENCY_THREE_PER_WEEK]: 3,
  [FREQUENCY_FOUR_PER_WEEK]: 4,
  [FREQUENCY_FIVE_PER_WEEK]: 5,
  [FREQUENCY_SIX_PER_WEEK]: 6,
  [FREQUENCY_ONE_PER_DAY]: 7,
};

export const maxPostsPerWeek = (frequencyKeys) => {
  const counts = (Array.isArray(frequencyKeys) ? frequencyKeys : [])
    .map((key) => FREQUENCY_POSTS_PER_WEEK[key])
    .filter((count) => Number.isFinite(count));
  if (!counts.length) return null;
  return Math.max(...counts);
};
